/**
 * Simple Cache for API-Calls
 */
export class Cache<T> {
    private items: Map<string, T> = new Map();

    set(url: string, data: T) {
        this.items.set(url, data);
    }

    get(url: string){
        return this.items.get(url);
    }
}